import {inject, singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {Project} from "../../domain/entities/project.entity";
import {MessageBroker} from "../../message-broker/message-broker";
import {EntityDeletedPayload} from "../../message-broker/payloads/entity-deleted.payload";
import {CommandBus} from "../../services/command-bus.service";
import {DeleteProjectCommand} from "../delete-project.command";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";

@CommandHandler(DeleteProjectCommand)
@singleton()
export class DeleteProjectCommandHandler implements ICommandHandler<Project> {

    constructor(
        @inject(CommandBus) private readonly _commandBus: CommandBus,
        @inject(MessageBroker) private readonly _messageBroker: MessageBroker
    ) {
    }

    public async handle(command: ICommand<Project>): Promise<void> {
        if (!(await this._commandBus.addSendCommand(command))) {
            return;
        }

        // The command already carries the full entity as its payload; no re-fetch.
        const entity = command.payload;
        if (!entity) {
            console.error(`Es wurde kein Projekt mit der UUID ${command.mainEntityUid} in der Persistenz gefunden.`);
            return;
        }

        this._messageBroker.publish<EntityDeletedPayload<Project>>({
            type: `entity.deleted`,
            identityHash: command.mainEntityUid,
            payload: {entity}
        });
    }
}